import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAlert } from "../contexts/AlertContext";
import "../styles/past-incidents.css";

export default function OAuthError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showAlert } = useAlert();

  useEffect(() => {
    const reason = searchParams.get("reason");

    if (reason === "invalid_domain") {
      showAlert("Invalid domain. Use a valid email.", "error");
    } else {
      showAlert("Login failed. Try again.", "error");
    }

    const timer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, searchParams, showAlert]);

  return <div className="page-state">Redirecting...</div>;
}
